export const defaultData = {
  name: '',
  email: '',
  pinCode: '',
  phoneNumber: '',
  customerSMSLanguages: '',
  additionalEmails: {},
  additionalPhoneNumbers: {},
  serviceRequest: false,
  shelvesNumber: 0,
  deliveryKeepTime: 0,
  deliveryReminderMessagePeriod: 0,
  strongAuthentication: '',
  pickupBox: {},
  pickUpMachine: false,
  zipCode: '',
  streetAddress: '',
  country: '',
  city: '',
  businessId: ''
};

export const infoOfPharmacy = [
  {
    label: 'pharmacy',
    type: 'text',
    name: 'name',
    validation: 'required',
    dataTestId: 'inputPharmacyName'
  },
  {
    label: 'farmacyEntryPin',
    type: 'text',
    name: 'pinCode',
    dataTestId: 'inputPharmacyPinCode'
  }
];

export const infoPhoneNumber = [
  {
    label: 'alarmPhoneNumber',
    type: 'tel',
    dataTestId: 'inputPharmacyAlarmPhoneNumber',
    name: 'phoneNumber',
    validation: [['required'], ['matches', /^\+[0-9]{10,14}$/]],
    validationVisibility: 'dirty'
  }
];

export const infoEmail = [
  {
    label: 'alarmEmail',
    type: 'email',
    name: 'email',
    validation: 'required|email',
    dataTestId: 'inputPharmacyAlarmEmail'
  }
];

export const infoOfDeliveries = [
  {
    label: 'deliveryExpirationTime',
    type: 'text',
    name: 'deliveryKeepTime',
    dataTestId: 'inputDeliveryKeepTime'
  },
  {
    label: 'reminderMessageTime',
    type: 'text',
    name: 'deliveryReminderMessagePeriod',
    dataTestId: 'inputDeliveryReminderMessagePeriod'
  }
];
